import React, { useState, useEffect, useContext } from 'react';
import { createMuiTheme, Slide, Container, Dialog, Toolbar, IconButton, Typography, Fab, CssBaseline, Backdrop, CircularProgress, Grid, AppBar } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { HttpService } from "../../../apiAuthorization/httpService";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import AddUserGroupUser from "./userGroupUserAdd"
import ConfirmDialog from "../../common/confirmDialog";
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function UserGroupUserList(props) {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const groupName = props.model.length === 0 ? '' : props.model.AppModuleGroupName;
    const [userName, setUserName] = useState('');
    const [backDrop, setBackDrop] = useState(true);
    const [userAddOpen, setUserAddOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [moduleGroupUsers, setModuleGroupUsers] = useState([]);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const closeGroupUser = () => {
        props.parentCallback();
    };

    const closeGroupUserAdd = () => {
        setUserAddOpen(false);
    };

    const openGroupUserAdd = () => {
        setUserAddOpen(true);
    };

    const updateList = (item) => {
        if (item !== null) {
            const data = moduleGroupUsers;
            data.push({ userName: item.AppUseUserName });
            setModuleGroupUsers(data);
        }
    };

    const deleteUserConfirm = (userName) => {
        setUserName(userName);
        setConfirmOpen(true);
    };

    const deleteGroupUser = () => {
        setConfirmOpen(false);
        setBackDrop(true);
        HttpService.post('/UserGroup/UnassignUserFromModuleGroup', { AppUseUserName: userName, AppModuleGroupName: groupName })
            .then((result) => {
                if (result.data) {
                    const data = moduleGroupUsers.filter(item => item.userName !== userName);
                    setModuleGroupUsers(data);
                }
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    const getModuleGroupUsers = () => {
        HttpService.post('/UserGroup/GetModuleGroupUsers', { AppModuleGroupName: groupName })
        .then((result) => {
            if (result.data) {
                setModuleGroupUsers(result.data);
                getUsers();
            }
        },
        (error) => {
            console.log(error);
        });
    };

    const getUsers = () => {
        HttpService.post('/UserGroup/GetAllAppUsers', null)
        .then((result) => {
            setUsers(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getModuleGroupUsers();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="userBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={userAddOpen} onClose={closeGroupUserAdd} TransitionComponent={Transition}>
                        <AddUserGroupUser parentCallback={closeGroupUserAdd}
                            refreshGrid={updateList}
                            model={props.model}
                            data={users}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={closeGroupUser} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>Group Users</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={openGroupUserAdd}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <div className="react-bootstrap-table" style={{ height: "600px", overflow: 'auto' }}>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Name</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-capitalize">
                                            {moduleGroupUsers?.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={rowStyle(index)}>{index + 1}</td>
                                                    <td style={rowStyle(index)}>{item.userName}</td>
                                                    <td style={rowStyle(index)}>
                                                        <DeleteIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => deleteUserConfirm(item.userName)} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deleteGroupUser}
                                    title="Delete User From User Group" message="Are you sure you want to delete the selected User from the Group?" />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
